import { store } from '../store/store';

const CategoryUtils = {
  getCategoryById: (id: string | undefined) => {
    const { categories } = store.getState();
    const category = categories.data?.find((category) => {
      return category?.id === id;
    });
    return category;
  },
  checkIfShowTitle: (categoryId: string) => {
    const category = CategoryUtils.getCategoryById(categoryId);
    if (category?.name === 'cine') {
      return false;
    }
    return true;
  },
};

export default CategoryUtils;
